<template>
  <section class="vacancies-section">
    <div class="container position-relative">
      <span v-bind="$parent.dKey('b7subtitle')" class="section-title wow fadeInUp" data-wow-duration="2s" data-wow-delay=".5s">{{subtitle}}</span>
      <h3 v-bind="$parent.dKey('b7title')" class="wow fadeInDown" data-wow-duration="2s" data-wow-delay=".5s">{{title}}</h3>
      <div class="row about-job-there">
        <div class="col-12 col-xl-6 job-description wow fadeIn" data-wow-duration="2s" data-wow-delay=".5s">
          <div v-bind="$parent.dKey('b7text')" v-html="content"></div>
          <router-link v-bind="$parent.dKey('b7linkName')" class="to-vacancies-btn" v-bind:to="'/' + $root.locale + '/vacancy'">{{linkText}}</router-link>
        </div>
        <div class="col-12 col-xl-5 workers-think ml-auto wow fadeInRight" data-wow-duration="2s" data-wow-delay=".5s">
          <div class="worker-description">
            <p v-bind="$parent.dKey('b7topWomen')">{{topWomen}}</p>
            <span v-bind="$parent.dKey('b7womenName')" class="worker-name">{{womenName}}</span>
            <span v-bind="$parent.dKey('b7whoWoman')" class="worker-position">{{whoWoman}}</span>
          </div>
        </div>
      </div>
      <div v-bind="$parent.dKey('b7vacantionDown')" class="grey-title-block resp-number wow fadeIn" data-wow-duration="2s" data-wow-delay=".5s">{{bgTitle}}</div>
    </div>
    <div class="worker-photo slideInUp" data-wow-duration="2s" data-wow-delay=".5s">
      <img src="/static-assets/img/antmanager.png" alt="">
    </div>
  </section>
</template>

<script>

export default {
  name: 'Vacancies',

  props: [
    'title', 'subtitle', 'bgTitle',
    'content', 'link', 'linkText',
    'topWomen', 'womenName', 'whoWoman'],

  mounted() {
    document.querySelectorAll('[data-key]').forEach(function(node){
      node.contentEditable = true
    })

    if (this.$root.isAdmin()) $('.to-vacancies-btn').off().on('click', function(event){
      event.preventDefault()
    })
  }
}

</script>
